import {sendGTMEvent} from '@next/third-parties/google';

export const QUERY_CONSTANTS = {
    INBOUND_REF: "r",
    TT_REF: "ref"
}

// Helper to get URL query parameters
const getQueryParam = (param: string): string | null => {
    if (typeof window === 'undefined') return null;
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
};

export const trackEvent = (eventName: string, params: Record<string, unknown> = {}) => {
    console.log('trackEvent', {eventName, ...params});
    sendGTMEvent({event: eventName, ...params});
};

export const trackPageView = (url: string) => {
    trackEvent('page_view', {page_location: url, page_title: document.title});
};

export const trackLinkClick = (href: string, linkType: 'inbound' | 'outbound', ref?: string | null) => {
    const params: Record<string, unknown> = {
        link_url: href,
        link_type: linkType,
    };
    if (ref) {
        params.ref_value = ref;
    }
    trackEvent('link_click', params);
};

export const trackReferral = (ref: string | null) => {
    trackEvent('referral_arrival', {ref_value: ref});
};

// Track initial referral if present
export const trackInitialReferral = () => {
    const ref = getQueryParam(QUERY_CONSTANTS.INBOUND_REF);
    if (ref) {
        trackReferral(ref);
    }
};

// Modify outbound links to include ref
export const modifyOutboundLink = (href: string, ref?: string | null): string => {
    if (!href) return href;
    try {
        const url = new URL(href);
        if (ref) {
            url.searchParams.set(QUERY_CONSTANTS.TT_REF, ref);
        }
        return url.toString();
    } catch (e) {
        console.error('Error modifying outbound link:', e);
        return href;
    }
};
